"use client";

import { graphql, useQuery } from "@opensea/graphql";
import { usePathname } from "@opensea/navigation";
import { Modal } from "@opensea/ui-kit";
import { useIsHydrated } from "@opensea/ui-kit/hooks";
import { TTL } from "@opensea/utils";
import { useEffect } from "react";
import { useStore } from "zustand";
import { withSuspense } from "../suspense/WithSuspense";
import { WhatsNewModalContent, WhatsNewModalContentFragment } from "./WhatsNewModalContent";
import { WhatsNewModalStore } from "./whats-new-modal-store";
const query = graphql(`
    query WhatsNewModalQuery($lastSeen: DateTime!) {
      whatsNew(lastSeen: $lastSeen) {
        ...WhatsNewModalContent
      }
    }
  `, [WhatsNewModalContentFragment]);
const CONTEXT = {
  ttl: TTL["5m"]
};
export const WhatsNewModal = withSuspense(function WhatsNewModal() {
  const pathname = usePathname();
  const {
    forceState,
    lastSeen,
    overrideLastSeen,
    close,
    setLastSeen
  } = useStore(WhatsNewModalStore);
  const isHydrated = useIsHydrated();
  useEffect(() => {
    if (isHydrated && lastSeen === null) {
      setLastSeen(new Date());
    }
  }, [isHydrated, lastSeen, setLastSeen]);
  const pause = forceState === "closed" || pathname !== "/" || lastSeen === null;
  const [{
    data
  }] = useQuery({
    query,
    variables: {
      lastSeen: overrideLastSeen ? new Date(overrideLastSeen).toISOString() : lastSeen ? new Date(lastSeen).toISOString() : new Date().toISOString()
    },
    pause,
    context: CONTEXT
  });
  if (!isHydrated) {
    return null;
  }
  const slides = data?.whatsNew ?? [];
  function getOpen() {
    if (lastSeen === null) {
      return false;
    }
    if (forceState === "open") {
      return true;
    }
    if (forceState === "closed") {
      return false;
    }
    return pathname === "/" && slides.length > 0;
  }
  return <Modal className="overflow-hidden bg-bg-app md:w-[540px]" content={<WhatsNewModalContent onClose={close} slides={slides} />} onOpenChange={setOpen => setOpen ? null : close()} open={getOpen()} withCloseIcon={false} />;
});